import { Pencil, Trash2 } from "lucide-react";
import { Button } from "../../../components/button";
import type { DataTableColumn } from "../../../components/table/data-table/DataTable";
import { organizationTypeLabels } from "../constants/organization.constants";
import type { Organization } from "../types/organization.types";

type OrganizationTableColumnActions = {
  onEdit: (organization: Organization) => void;
  onDelete: (organization: Organization) => void;
};

export function createOrganizationTableColumns({
  onEdit,
  onDelete,
}: OrganizationTableColumnActions): DataTableColumn<Organization>[] {
  return [
    {
      key: "logo",
      title: "Logo",
      minWidth: 88,
      align: "center",
      render: (organization) =>
        organization.icon_url ? (
          <img
            src={organization.icon_url}
            alt={`${organization.name} logo`}
            className="mx-auto h-10 w-10 rounded-full border border-slate-200 object-cover"
          />
        ) : (
          "—"
        ),
    },
    {
      key: "name",
      title: "Organization",
      minWidth: 200,
      render: (organization) => <span className="font-semibold">{organization.name}</span>,
    },
    {
      key: "type",
      title: "Type",
      minWidth: 160,
      render: (organization) =>
        organization.organization_type ? organizationTypeLabels[organization.organization_type] : "—",
    },
    { key: "state", title: "State", minWidth: 140, render: (organization) => organization.state || "—" },
    {
      key: "actions",
      title: "Actions",
      align: "right",
      minWidth: 120,
      render: (organization) => (
        <div className="flex justify-end gap-1">
          <Button type="button" variant="ghost" size="icon" aria-label={`Edit ${organization.name}`} onClick={() => onEdit(organization)}>
            <Pencil className="h-4 w-4" />
          </Button>
          <Button type="button" variant="ghost" size="icon" aria-label={`Delete ${organization.name}`} onClick={() => onDelete(organization)}>
            <Trash2 className="h-4 w-4 text-[#EC5454]" />
          </Button>
        </div>
      ),
    },
  ];
}
